import { combineReducers } from "redux";
import { Run } from "../../../../types/entities/run";
import { Version } from "../../../../types/entities/version";
import { kernelDrafts, State as KernelDrafts } from "./kernelDrafts";
import { runs } from "./runs";
import { versions } from "./versions";

export interface State {
  runs: { [id: number]: Run };
  versions: { [id: number]: Version };
  kernelDrafts: KernelDrafts;
}

export const entities = combineReducers({
  versions,
  runs,
  kernelDrafts,
});
